import type { InferOutput } from "valibot"
import { picklist } from "valibot"

export const idspSchema = picklist([
  "vipps",
  "feide",
])

export type Idsp = InferOutput<typeof idspSchema>

export const IDSP_MAPPING = {
  vipps: "vipps_kunne_oidc_tree",
  feide: "skoleFeide",
} as const satisfies Record<Idsp, string>
